import { SVGProps } from "react";

type Props = SVGProps<SVGSVGElement>;

/**
 * Optimized with https://jakearchibald.github.io/svgomg/
 */
const SVGPhone: React.FC<Props> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 64 64"
    stroke="currentColor"
    {...props}
  >
    <title>Bormioli Pharma</title>
    <path
      d="M21.001 54h22M30.001 10h4M40.334 60H23.668C19.984 60 17 55.823 17 50.667V13.333C17.001 8.177 19.984 4 23.668 4h16.666c3.684 0 6.667 4.177 6.667 9.333v37.334c0 5.156-2.983 9.333-6.667 9.333Z"
      stroke="#25262E"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SVGPhone;
